import { render, staticRenderFns } from "./foodExpenseDetailSchool.vue?vue&type=template&id=bdfde7c0&scoped=true&"
import script from "./foodExpenseDetailSchool.vue?vue&type=script&lang=js&"
export * from "./foodExpenseDetailSchool.vue?vue&type=script&lang=js&"
import style0 from "./foodExpenseDetailSchool.vue?vue&type=style&index=0&id=bdfde7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfde7c0",
  null
  
)

export default component.exports